"use strict";


/**
 * @type Controller
 * @name stationRemove_ctrl
 * @packageName stationRemove_dialog_ctrl.js
 *
 */
class stationRemove_ctrl {


    constructor($scope, $mdDialog, $http, station) {

        $scope.$http = $http;
        this.$mdDialog = $mdDialog;

        //Attach dependicies to class root
        $scope.$mdDialog = $mdDialog;


        //Close dialog
        $scope.hideDialog = () => {
            this.cancelButton();
        };

        $scope.confirmDialog = () => {
            this.confirmButton();
        };

        $scope.station = station;

    }

    cancelButton() {
        this.$mdDialog.cancel();
    }

    confirmButton() {
        this.$mdDialog.hide();
    }
}


/*
 * Inject dependicies
 */
stationRemove_ctrl.$inject = ['$scope', '$mdDialog', '$http', 'station'];


/*
 * Browsify connection: execute controller
 */
module.exports = stationRemove_ctrl;
